export enum BetStatusAbrv {
	CANCELLED = "cancelled",
	LOST = "lost",
	WON = "won",
	OPEN = "open",
	RETURNED = "returned",
}
